import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="pointer-events-none select-none text-9xl font-black text-primary-100 md:text-[12rem]">
        404
      </span>
      <h1 className="mt-2 text-xl font-semibold text-foreground-900 md:text-2xl">
        This page has not been generated
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        Tell me more about this page, so I can generate it
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
      >
        <span className="mr-2 flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-line"></i>
        </span>
        Back to Home
      </Link>
    </div>
  );
}